<div
  class="grade-level-container"
  *ngIf="gradingPeriods.length; else elseBlock"
>
  <h2 class="heavy-header-text header-style">Select a Grading Period</h2>
  <ng-container>
    <app-pill-button-list
      [gradingLink]="link"
      [gradingPeriods]="gradingPeriods"
      (selectionEvent)="propagateSelection($event)"
    ></app-pill-button-list>
  </ng-container>
</div>

<ng-template #elseBlock>
  <div class="grade-level-container">
    <h2 class="header-style">There are no Grading Periods created.</h2>
  </div>
</ng-template>
